(() => {
  const promises = new Map();

  async function loadPDF(day) {
    const dayKey = String(day);
    const expectedVersion = window.NanaRecipePDFExpectedVersions?.[dayKey];
    const cached = window.NanaRecipePDFCache?.[dayKey];
    if (cached && (!expectedVersion || cached.version === expectedVersion)) return cached;

    const promiseKey = `${dayKey}:${expectedVersion || 'legacy'}`;
    if (promises.has(promiseKey)) return promises.get(promiseKey);

    const src = window.NanaRecipePDFAssetURLs?.[dayKey];
    if (!src || !/^https:\/\//.test(src)) throw new Error('PDF asset is not configured');

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => {
        script.remove();
        const record = window.NanaRecipePDFCache?.[dayKey];
        if (record && (!expectedVersion || record.version === expectedVersion)) {
          resolve(record);
          return;
        }
        reject(new Error('PDF asset did not register the expected version'));
      };
      script.onerror = () => {
        script.remove();
        reject(new Error('PDF could not load'));
      };
      document.head.append(script);
    });

    promises.set(promiseKey, promise);
    try {
      return await promise;
    } finally {
      promises.delete(promiseKey);
    }
  }

  window.NanaRecipePDFLoader = { load: loadPDF };
})();
